<template>
  <div class="flex flex-col items-center gap-y-3.5">
    <UiIcon class="mx-auto w-20 flex-1 text-white" name="search-no-results" />
    <p class="ui-text-m font-medium capitalize text-white">
      {{ $t("noResultsFound") }}
    </p>
    <p class="text-center ui-text-sm text-white">
      {{ $t("noResultsFoundText") }}.
    </p>
  </div>
</template>
